import { reactContainer } from '@shared/Frontend/utils/reactContainer'
import 'custom-event-polyfill'
import i18next from 'i18next'
import { useState } from 'react'
import { createRoot } from 'react-dom/client'
import 'whatwg-fetch'
import '../../Styling/frontend/stylesheets/frontend.scss' // PROJECT STYLES
import { Language } from './legacy/public_site/components/drupal/types_and_parser/types.ext.gen'
import { defaultLanguage, getLangFromUrl } from './legacy/public_site/components/public_site/utils/history.mod'
import { initialRootState } from './root/state'
import { rootWidget } from './root/widget'
import React = require('react')

export const publicSite = async () => {
  const res = await fetch('/api/v1/translations')
  const resources = await res.json()
  const language = getLangFromUrl()

  await i18next.init({ lng: language, fallbackLng: defaultLanguage, resources: resources })

  if (reactContainer != null) {
    const root = createRoot(reactContainer)
    root.render(<PublicSite language={language} />)
  }
}

const PublicSite = ({ language }: { language: Language }) => {
  const [rootState, setRootState] = useState(initialRootState)
  return rootWidget(language)(rootState).run(setRootState)
}

publicSite()
